module.exports = __webpack_public_path__ + "static/CustomWebsiteDevelopment-5537a688fb7afaa72c37b05db9494a90.jpeg";